import React, { useContext } from "react";
import "./AIHacking.scss";
import { aiHackingSection } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function AIHacking() {
  const { isDark } = useContext(StyleContext);

  if (!aiHackingSection.display) {
    return null;
  }

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="ai-hacking">
        <div className="ai-hacking-header">
          <h1 className="ai-hacking-header-title">{aiHackingSection.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode ai-hacking-header-subtitle"
                : "subTitle ai-hacking-header-subtitle"
            }
          >
            {aiHackingSection.subtitle}
          </p>
        </div>
        <div className="ai-hacking-grid">
          {aiHackingSection.videos.map((video, i) => (
            <div key={i} className="ai-hacking-video-wrapper">
              <iframe
                className="ai-hacking-video"
                src={video.embedUrl}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          ))}
        </div>
      </div>
    </Fade>
  );
}
